import { Navis } from "@maven-surface/layouts/Sidebar";

const navis: Navis = [];

const resources: Navis = [];

export { navis, resources };
